<template>
  <ul class="menu menu--cms vertical" :class="[`level-${level}`]">
    <nuxt-link v-for="(item, index) in filteredItems" :key="index" tag="li" :to="{ path: $get(item, 'uri') }">
      <a>{{ $get(item, 'title') }}</a>
      <CmsMenu v-if="getIfHasChildren(item)"
               :items="$get(item, 'children', [])"
               :level="level + 1" />
    </nuxt-link>
  </ul>
</template>

<script>
  export default {
    name: 'CmsMenu',
    props: {
      items: {
        default: () => [],
        type: Array,
      },
      level: {
        default: 1,
        type: Number,
      },
    },
    computed: {
      filteredItems () {
        return this.getChildren({ children: this.items })
      },
    },
    methods: {
      /**
       * Use this method to filter out unwanted items.
       * @param item
       */
      getChildren (item) {
        const children = this.$get(item, 'children', [])

        return children.filter(item => {
          return item.slug !== 'terms-old'
        })
      },
      getIfHasChildren (item) {
        return this.getChildren(item).length > 0
      },
    },
  }
</script>

<style lang="scss">
  @import "~assets/scss/frontend/_colours";
  @import "~assets/scss/frontend/_settings";
  @import "~foundation-sites/scss/global";

  .menu--cms {
    li {
      a {
        background: $colour-magnolia-light;
        border: {
          left: $global-border;
          bottom: $global-border;
          right: $global-border;
          top: none;
        }
        font: {
          size: 1rem;
          weight: normal;
        }
        padding: rem-calc(20);
      }

      &.nuxt-link-exact-active {
        > a {
          border-left: rem-calc(5) solid $colour-orange-light;
        }
      }
    }

    &.level-1 {
      > li:first-child {
        > a:first-child {
          border-top: $global-border;
        }
      }
    }
    &.level-2 {
      margin-left: rem-calc(7);

      a {
        background: mix($colour-magnolia-light, $colour-magnolia-dark, 85%);
      }

      li {
        &.nuxt-link-active {
          display: block;
        }
      }
    }
    &.level-3 {
      margin-left: rem-calc(7);

      a {
        background: mix($colour-magnolia-light, $colour-magnolia-dark, 70%);
      }
    }
  }

  .menu--cms {
    > li {
      display: none;
    }
    &.level-1 > li {
      display: block;
    }

    @at-root .nuxt-link-active > & > li {
      display: block;
    }
  }
</style>
